import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ShoppingCart, ClipboardCheck, PackageCheck, Clock } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { isBuyNow, stockStatus, stockLabel, quoteLabel } from '../lib/shop';
import { buildContactHref } from './CTASection';

export const StockBadge = ({ m, testid }) => {
    const s = stockStatus(m);
    const Icon = s === 'in_stock' ? PackageCheck : Clock;
    const color = s === 'in_stock' ? 'text-emerald-700 bg-emerald-50 border-emerald-200' : 'text-amber-800 bg-amber-50 border-amber-200';
    return (
        <span className={`inline-flex items-center gap-1.5 border px-2 py-1 text-xs font-semibold ${color}`} data-testid={testid || `stock-badge-${m.id}`}>
            <Icon className="h-3.5 w-3.5" /> {stockLabel(m)}
        </span>
    );
};

export const AddToCartButton = ({ m, qty = 1, className = '', testid }) => {
    const { add } = useCart();
    const onClick = () => {
        add(m, qty);
        toast.success(`${m.name} added to cart`, { action: { label: 'View cart', onClick: () => { window.location.href = '/cart'; } } });
        if (window.trackConversion) window.trackConversion('add_to_cart', { machine: m.name, qty });
    };
    return (
        <button
            type="button"
            onClick={onClick}
            className={`inline-flex items-center justify-center gap-2 bg-brand-primary hover:bg-brand-primaryHover text-white font-bold label-caps transition-colors ${className}`}
            data-testid={testid || `add-to-cart-${m.id}`}
        >
            <ShoppingCart className="h-4 w-4" /> Add to Cart
        </button>
    );
};

export const QuoteButton = ({ m, className = '', testid }) => (
    <Link
        to={buildContactHref({ subject: `${quoteLabel(m)}: ${m.name}`, machine: m.name, interest: 'quote' })}
        onClick={() => window.trackConversion && window.trackConversion('equipment_quote_click', { machine: m.name })}
        className={`inline-flex items-center justify-center gap-2 bg-neutral-900 hover:bg-brand-primary text-on-dark font-bold label-caps transition-colors ${className}`}
        data-testid={testid || `quote-btn-${m.id}`}
    >
        <ClipboardCheck className="h-4 w-4" /> {quoteLabel(m)}
    </Link>
);

export const PrimaryShopAction = ({ m, className, testid }) => (
    isBuyNow(m) ? <AddToCartButton m={m} className={className} testid={testid} /> : <QuoteButton m={m} className={className} testid={testid} />
);
